export default {
  color: '#004563',
  failedColor: '#FF0000',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  }
}



// WEBPACK FOOTER //
// ./src/mixins/progressBarOptions.js